import React, { useState, useEffect, useRef } from 'react';

const SKILLS_DATA = [
  {
    cat: 'Frontend', icon: '🎨',
    skills: [
      ['React / Next.js', 98],
      ['TypeScript', 90],
      ['Tailwind CSS', 95],
      ['Framer Motion', 88],
    ],
  },
  {
    cat: 'Backend', icon: '⚙️',
    skills: [
      ['Node.js / Express', 95],
      ['REST APIs', 97],
      ['WebSockets', 82],
    ],
  },
  {
    cat: 'Database & Cloud', icon: '🗄️',
    skills: [
      ['MongoDB', 92],
      ['Firebase', 88],
      ['AWS / GCP', 78],
      ['Netlify / Vercel', 96],
    ],
  },
  {
    cat: 'Design & Tools', icon: '🛠️',
    skills: [
      ['Figma', 92],
      ['Git / GitHub', 96],
      ['Docker', 75],
      ['CI / CD Pipelines', 80],
      ['Agile / Scrum', 90],
    ],
  },
];

const SkillPanel = ({ data }) => {
  const [widths, setWidths] = useState(data.skills.map(() => 0));
  const panelRef = useRef(null);

  useEffect(() => {
    setWidths(data.skills.map(() => 0));
    const timer = setTimeout(() => {
      setWidths(data.skills.map(([, pct]) => pct));
    }, 50);
    return () => clearTimeout(timer);
  }, [data]);

  return (
    <div className="glass-card skill-panel" ref={panelRef}>
      <div className="panel-head">
        <span className="panel-icon">{data.icon}</span>
        <div className="panel-title">{data.cat}</div>
      </div>
      <div className="skill-bars">
        {data.skills.map(([name, pct], i) => (
          <div key={name} className="skill-bar-item">
            <div className="skill-bar-meta">
              <span className="skill-name">{name}</span>
              <span className="skill-pct">{pct}%</span>
            </div>
            <div className="skill-track">
              <div
                className="skill-fill"
                style={{ width: `${widths[i]}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Skills = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section id="skills">
      <div className="container">
        <span className="section-tag">Expertise</span>
        <h2 className="section-title">
          FULL-STACK<br />
          <span className="gradient-text">MASTERY</span>
        </h2>
        <div className="glow-line" />
        <p className="section-subtitle" style={{ marginBottom: '56px' }}>
          From pixel-perfect UIs to scalable Node.js backends and cloud deployments — every layer covered.
        </p>

        <div className="skills-layout">
          <div className="skills-tabs">
            {SKILLS_DATA.map((tab, i) => (
              <button
                key={tab.cat}
                className={`skill-tab${activeTab === i ? ' active' : ''}`}
                onClick={() => setActiveTab(i)}
              >
                {tab.icon} {tab.cat}
              </button>
            ))}
          </div>

          <SkillPanel data={SKILLS_DATA[activeTab]} />
        </div>
      </div>
    </section>
  );
};

export default Skills;
